import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'plant-report',
  templateUrl: './plant.component.html',  
})

export class VehiclePlantComponent {
  prjId: any;
  isLko: boolean;
 
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
    this.prjId = this.auth.getAuthentication().projectId
    console.log(this.prjId);
    if(this.prjId == 1){
      this.isLko = true
    }
  }

}
 


// WEBPACK FOOTER //
// ./src/app/reports/plant/plant.component.ts